import { Select } from "@light-technology/components";
import { Calendar } from "@untitledui/icons";
import type { Key } from "react";
import { TERM_MONTHS_ITEMS, type TermMonths } from "./common";

type TermMonthsSelectProps = {
  value: TermMonths;
  onChange: (value: TermMonths) => void;
};

export const TermMonthsSelect = ({
  value,
  onChange,
}: TermMonthsSelectProps) => {
  return (
    <Select
      label="Term length"
      items={TERM_MONTHS_ITEMS}
      value={value}
      onChange={(value: Key | null) => {
        const item = TERM_MONTHS_ITEMS.find((item) => item.id === value);
        if (item) {
          onChange(item.id as TermMonths);
        }
      }}
      placeholderIcon={Calendar}
      className="min-w-40"
      aria-label="Select term months"
      isRequired
    >
      {(item) => <Select.Item id={item.id}>{item.label}</Select.Item>}
    </Select>
  );
};
